<template>
  <div>
    <v-data-table
        :loading="loadingMeasurements"
        :headers="headersMeasurements"
        :options.sync="paginationMeasurements"
        :server-items-length="totalMeasurements"
        :items-per-page-options="rowsPerPage"
        :footer-props="footerOptions"
        :items="measurements"
        :page.sync="currentPage"
        mobile-breakpoint="0"
    >
      <div>

      </div>
      <template v-slot:item.actions="{ item }">
        <template v-if="!isInvoiceForm">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="showMeasurement(item.id)">
                <v-icon color="fontDefault">edit</v-icon>
              </v-btn>
            </template>
            <span>{{ languageData.labels.edit }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="downloadMeasurement(item)"
                  :loading="item === isMeasurementGenerating[isMeasurementGenerating.indexOf(item)]"
                  icon>
                <v-icon color="fontDefault">mdi-file-download</v-icon>
              </v-btn>
            </template>
            <span>{{ languageData.labels.download }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="showDeleteMeasurementModal(item)"
              >
                <v-icon color="fontDefault">delete</v-icon>
              </v-btn>
            </template>
            <span>{{ languageData.labels.delete }}</span>
          </v-tooltip>
        </template>
        <template v-else>
            <v-btn
                color="primary"
                @click="showMeasurementItemsModal(item)"
            >
              {{ languageData.select }}
            </v-btn>
        </template>
      </template>
    </v-data-table>
    <ModalInfo
        v-if="!project"
        @doOperation="removeMeasurement(measurementToDelete)"
        :isLoadingBtn="false"
        :typeInfo="'success'"
        :headModal="languageData.modalDeleteMeasurement.head"
        :btnDisAgreeText="languageData.modalDeleteMeasurement.btnDisAgreeText"
        :btnAgreeText="languageData.modalDeleteMeasurement.btnAgreeText"
        :visDisAgreeBtn="true" @clicked="hideModalDeleteMeasurement"
        :show-modal="isShowDeleteMeasurementModal"
        :text-modal="languageData.modalDeleteMeasurement.textInfo + '' + measurementToDelete.id ">

    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideMeasurementItemsModal" :show-modal="isShowMeasurementItemsTable">
      <template v-slot:body>
        <MeasurementItemsTable isMeasurement :tableHeaders="headersMeasurementItems" :invoiceItems="invoiceItems"></MeasurementItemsTable>
      </template>
    </ModalInfo>
  </div>
</template>

<script>

import eventBus from "../../../event-bus/eventBus";
import {mapActions, mapState} from 'vuex';
import ModalInfo from "../../../components/ModalInfo/ModalInfo";
import MeasurementItemsTable from "./MeasurementItemsTable";

export default {
  name: "MeasurementsTable",
  components: {MeasurementItemsTable, ModalInfo},
  props: {
    isInvoiceForm: Boolean,
    invoiceItems: Array,
    project: [Object, null],
  },
  data() {
    return {
      footerOptions: {
        'items-per-page-options': [20, 50, 100],
        'disablePagination': false
      },
      currentPage: 1,
      isShowDeleteMeasurementModal: false,
      measurementToDelete: {},
      isShowMeasurementItemsTable: false,
    }
  },
  methods: {
    ...mapActions("getMeasurements", ["getMeasurements"]),
    ...mapActions("showEstimationModal", ["updateVisibleEstimationModal", "updateIsMeasurementState", "updateMeasurementEditId"]),
    ...mapActions("deleteMeasurement", ["deleteMeasurement"]),
    ...mapActions("generateMeasurementPdf", ["generateMeasurement"]),
    ...mapActions("getEstimate", ["getEstimate"]),
    ...mapActions("getHeadersMeasurementItems", ["getHeadersMeasurementItemsRequest"]),
    ...mapActions("getMeasurements", ["getHeadersTable"]),

    searchMeasurements: function(valueSearch = {}, filters=false) {
      valueSearch.language = this.getCurrentLanguage;
      valueSearch.filters = filters;
      const urlParams = new URLSearchParams(window.location.search);
      valueSearch.projectId = this.project !== undefined ? this.project.id : urlParams.get("id");
      this.getMeasurements({ valueSearch });
      if(filters) {
        this.currentPage = 1;
      }
    },
    showMeasurement(id) {
      this.updateVisibleEstimationModal(true);
      this.updateIsMeasurementState(true);
      this.updateMeasurementEditId(id);
      eventBus.$emit('getMeasurementEvent', id);
    },
    showDeleteMeasurementModal(item) {
      this.isShowDeleteMeasurementModal = true;
      this.measurementToDelete.id = item.id;
    },
    hideModalDeleteMeasurement() {
      this.isShowDeleteMeasurementModal = false;
    },
    removeMeasurement(item) {
      let indexItem = this.measurements.indexOf(item);
      let id = item.id;
      this.deleteMeasurement({ creds: { id, indexItem } });
    },
    downloadMeasurement(item) {
      this.generateMeasurement({item});
    },
    showMeasurementItemsModal(item) {
      this.isShowMeasurementItemsTable = true;
      let data = {id: this.project ? this.project.id : null, measurementId: item.id}
      this.getEstimate(data)
    },
    hideMeasurementItemsModal() {
      this.isShowMeasurementItemsTable = false;
    },
    getSnackBar: function(title, message, icon, color) {
      this.snackbar = {
        color: color,
        icon: icon,
        mode: "multi-line",
        position: "top",
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    }
  },
  computed: {
    ...mapState("getMeasurements", {
      headersMeasurements: state => state.headers,
      totalMeasurements: state => state.pagination.totalItems,
      rowsPerPage: state => state.pagination.rowsPerPage,
      measurements: state => state.dataReceive,
      loadingMeasurements: state => state.loadingMeasurements
    }),
    ...mapState("generateMeasurementPdf", {
      isMeasurementGenerating: state => state.isMeasurementGenerating
    }),
    ...mapState("getHeadersInvoiceItems", {
      headersInvoiceItems: state => state.headers
    }),
    ...mapState("getHeadersMeasurementItems", {
      headersMeasurementItems: state => state.headers,
    }),

    paginationMeasurements: {
      set: function(value) {
        this.searchMeasurements(value);
      },
      get: function() {
        return this.$store.state.getMeasurements.pagination;
      }
    },
  },
  mounted() {
    if(this.isInvoiceForm) {
      this.getHeadersMeasurementItemsRequest({ creds: { language: this.getCurrentLanguage } });
    }

    if(this.project) {
      this.getHeadersTable({ creds: { language: this.getCurrentLanguage } })
    }
    eventBus.$on("saveMeasurementSuccess", () => {
      this.searchMeasurements({ creds: { language: this.getCurrentLanguage } });
    });

    eventBus.$on("successDeleteMeasurement", (dataReceive) => {
      this.searchMeasurements();
      this.getSnackBar(dataReceive.title, dataReceive.message, "check_circle", "success");
    });

    eventBus.$on("searchMeasurements", () => {
      this.searchMeasurements();
    });

  },
  beforeDestroy() {
    eventBus.$off("saveMeasurementSuccess");
    eventBus.$off("successDeleteMeasurement");
    eventBus.$off("searchMeasurements");
  }

}

</script>
